import React, { useState, useEffect } from 'react';
import { round } from 'lodash';
import PropTypes from 'prop-types';
import { Table, Tr, TdImp, Td } from './css';
import request from '../../../utils/request';
import { TrError } from '../selectionGrid/css';
import { managedDetectionResponse } from '../../../utils/constant';

const FmManagedDetectionResponse = ({
  onChange,
  defaultValues,
  orderData,
  errors
}) => {
  const [loading, setLoading] = useState(true);
  const [feeData, setFeeData] = useState(
    defaultValues && defaultValues.feeData
      ? defaultValues.feeData
      : { id: '', name: '', note: '', amount: 0 }
  );
  const [numberOfUsers, setNumberOfUsers] = useState(
    defaultValues && defaultValues.numberOfUsers
      ? defaultValues.numberOfUsers
      : 0
  );
  const [totalCost, setTotalCost] = useState(
    defaultValues && defaultValues.totalCost ? defaultValues.totalCost : 0
  );
  const [totalPrice, setTotalPrice] = useState(
    defaultValues && defaultValues.totalPrice ? defaultValues.totalPrice : 0
  );
  const [onboardingFee, setOnboardingFee] = useState(
    defaultValues && defaultValues.onboardingFee
      ? defaultValues.onboardingFee
      : 0
  );
  const [
    managedDetectionResponseData,
    setManagedDetectionResponseData
  ] = useState(
    defaultValues && defaultValues.managedDetectionResponseData
      ? defaultValues.managedDetectionResponseData
      : []
  );
  const [showFee, setShowFee] = useState(
    defaultValues && defaultValues.numberOfUsers > 0
  );

  const offeringId = 6;
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await request.get('/productCatalog/offerings/6');

        if (
          response &&
          response.data &&
          response.data.ServicesInOffering
        ) {
        //   const offerings = response.data[0].productCatalogOfferings;
        //   let mdrData = offerings.find(
        //     offering =>
        //       offering.id === 6 && offering.name === managedDetectionResponse
        //   );

          setManagedDetectionResponseData(response.data.ServicesInOffering || []);
            if (response.data.productCatalogFees) {

            // const feeResponse = await request.get(
            //   `/productCatalog/offerings/${offeringId}/fees`
            // );
            // if (feeResponse && feeResponse.data && feeResponse.data[0]) {
              setFeeData(response.data.productCatalogFees[0]);
            // }
          }
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (
      managedDetectionResponseData.length === 0 ||
      !managedDetectionResponseData[0] ||
      !managedDetectionResponseData[0].productCatalogQuantities
    )
      return;

    const service = managedDetectionResponseData[0];
    const quantity =
      service.productCatalogQuantities.length > 0
        ? service.productCatalogQuantities[0]
        : null;

    if (!quantity) return;

    const { id, name, isRequired, note, productCatalogPricing } = quantity;
    const { cost, onetimePrice } = productCatalogPricing;

    const adjustedTotalCost = round(cost * numberOfUsers, 2);
    const adjustedTotalPrice = round(onetimePrice * numberOfUsers, 2);
    let adjustedOnboardingFee = feeData.amount;
    if (numberOfUsers > 0) {
      if (adjustedTotalPrice < feeData.amount) {
        adjustedOnboardingFee = feeData.amount;
      } else if (adjustedTotalPrice > feeData.amount) {
        adjustedOnboardingFee = adjustedTotalPrice;
      }
    } else {
      adjustedOnboardingFee = 0;
    }

    setTotalCost(adjustedTotalCost);
    setTotalPrice(adjustedTotalPrice);
    setOnboardingFee(adjustedOnboardingFee);
    setShowFee(numberOfUsers > 0);
    onChange({
      numberOfUsers,
      totalCost: adjustedTotalCost,
      totalPrice: adjustedTotalPrice,
      onboardingFee: adjustedOnboardingFee,
      mdrData: { id, name, isRequired, note, cost, onetimePrice },
      feeData
    });
  }, [numberOfUsers, managedDetectionResponseData,feeData]);

  return (
    <div>
      <Table>
        <Tr>
          <TdImp>
            {managedDetectionResponseData.length > 0 &&
            managedDetectionResponseData[0] &&
            managedDetectionResponseData[0].productCatalogQuantities &&
            managedDetectionResponseData[0].productCatalogQuantities.length > 0
              ? `${
                  managedDetectionResponseData[0].productCatalogQuantities[0]
                    .name
                }${
                  managedDetectionResponseData[0].productCatalogQuantities[0]
                    .isRequired
                    ? '*'
                    : ''
                }`
              : 'Label not added'}
            {managedDetectionResponseData.length > 0 &&
              managedDetectionResponseData[0] &&
              managedDetectionResponseData[0].productCatalogQuantities &&
              managedDetectionResponseData[0].productCatalogQuantities.length >
                0 && (
                <span
                  style={{
                    display: 'block',
                    fontWeight: 'lighter',
                    fontStyle: 'italic',
                    fontSize: '13px'
                  }}
                >
                  {
                    managedDetectionResponseData[0].productCatalogQuantities[0]
                      .note
                  }
                </span>
              )}
          </TdImp>
          <Td>
            <input
              type="text"
              value={numberOfUsers}
              onChange={e => {
                const value = e.target.value;

                // Allow only digits (prevent non-numeric input)
                if (/^\d*$/.test(value)) {
                  setNumberOfUsers(value === '' ? '' : Number(value)); // Convert to number if not empty
                }
              }}
              placeholder="Number Of Users"
              className="frg-input-field color-light"
              onWheel={e => e.target.blur()}
            />
          </Td>
        </Tr>
        <Tr>
          <TdImp>Total Cost</TdImp>
          <Td>
            <input
              type="text"
              value={`$${totalCost.toFixed(2)}`}
              disabled
              className="frg-input-field color-light"
            />
          </Td>
        </Tr>
        <Tr>
          <TdImp>Total Price</TdImp>
          <Td>
            <input
              type="text"
              value={`$${totalPrice.toFixed(2)}`}
              disabled
              className="frg-input-field color-light"
            />
          </Td>
        </Tr>
        {showFee && (
          <Tr>
            <TdImp>{feeData.name}</TdImp>
            <Td>
              <input
                type="text"
                value={`$${onboardingFee.toFixed(2)}`}
                disabled
                className="frg-input-field color-light"
              />
            </Td>
          </Tr>
        )}
        {Object.keys(errors).length > 0 && (
          <TrError>
            <Td colSpan={3} style={{ textAlign: 'left' }}>
              {errors.numberOfUsers}
            </Td>
          </TrError>
        )}
      </Table>
    </div>
  );
};

FmManagedDetectionResponse.propTypes = {
  onChange: PropTypes.func.isRequired,
  defaultValues: PropTypes.shape({}).isRequired
};

export default FmManagedDetectionResponse;
